export enum ELOOKUPVALUECODES {
    ALL_ROLE = 'lookupValue/ALL_ROLES',
    LIMIT_FUNCTIONS = 'lookupValue/LIMIT_FUNCTIONS',
    TABLE_REPORT_FILTER_VIEW = 'lookupValue/TABLE_REPORT_FILTER_VIEW',
}
export enum EFUNCTIONCODES {
    FORBID_TO_FOLLOW_LINK = 'FORBID_TO_FOLLOW_LINK',
    FORBID_TO_WATCH_DD = 'FORBID_TO_WATCH_DD'
}
